import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

import BannerCard from 'components/BannerCard';

import { bannerSliderSettings } from 'config/sliderSettings';
import Course from 'models/course';
import { getCourses } from 'services/course';

const BannerCardContainer = styled.div`
  width: 100vw;
  max-width: 1300px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const Banner: React.FC = () => {
  const [bannerCourses, setBannerCourses] = useState<Course[]>([]);

  useEffect(() => {
    (async () => {
      const courses = await getCourses({});
      if (courses) {
        const format = courses.filter(course => course.isHighlighted);
        setBannerCourses(format);
      }
    })();
  }, []);

  if (bannerCourses && bannerCourses.length) {
    if (bannerCourses.length > 1) {
      return (
        <Slider {...bannerSliderSettings}>
          {bannerCourses &&
            bannerCourses.length &&
            bannerCourses.map(course => (
              <BannerCard key={course.id} course={course} />
            ))}
        </Slider>
      );
    } else {
      const firstCourse = bannerCourses.find(ban => ban.id) || ({} as Course);
      return (
        <BannerCardContainer>
          <BannerCard
            key={firstCourse.id}
            course={firstCourse}
            style={{ transform: 'inherit' }}
          />
        </BannerCardContainer>
      );
    }
  } else {
    return <></>;
  }
};

export default Banner;
